import Highcharts from 'highcharts';

export const figure15 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 300,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [
          "Albania 2005",
          "Armenia 2013",
          "Bangladesh 2010",
          "Bolivia (Estado Plurinacional de) 2008",
          "Bulgaria 2007",
          "Burkina Faso 2014",
          "Camboya 2009",
          "Camerún 2014",
          "Ecuador 2014",
          "Etiopía 2016",
          "Georgia 2015",
          "Ghana 2013",
          "Guatemala 2014",
          "India 2012",
          "Iraq 2012",
          "Kenya 2005",
          "Kirguistán 2013",
          "Malawi 2017",
          "Malí 2017",
          "México 2014",
          "Mongolia 2014",
          "Mozambique 2009",
          "Nepal 2011",
          "Nicaragua 2014",
          "Níger 2014",
          "Nigeria 2019",
          "Pakistán 2014",
          "Panamá 2008",
          "Perú 2019",
          "Rwanda 2014",
          "Senegal 2011",
          "Serbia 2007",
          "Sierra Leona 2011",
          "República Unida de Tanzanía 2015",
          "Timor-Leste 2007",
          "Uganda 2016",
          "Viet Nam 2010",
       ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
              return this.value / 1000 + "M";
          },
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 6000,
        min: 0,
        tickInterval: 1000,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Hogares de pequeños productores encabezados por mujeress',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 2243.78, 834.6951201, 561.7713959, 1638.907425, 993.9554444, 299.2350626, 1362.691651, 1922.164652, 1553.084253, 485.251353, 1663.237432, 1391.803, 2054.702444, 1523.75072, 2950.60454, 784.3982925, 1771.721171, 452.040107, 705.656033, 1189.851294, 3620.181053, 264.1104962, 1010.565517, 997.9732208, 216.5654606, 293.2904829, 2529.987989, 1000.277222, 1041.879007, 277.407759, 810.6785546, 2591.606462, 743.2873517, 531.0745738, 1148.256752, 615.8584135, 2328.149351 ],
      },
      {
        name: 'Hogares de pequeños productores encabezados por hombres',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[ 3046.45, 1117.140959, 1187.647478, 2009.992687, 1581.328985, 797.7576527, 1394.39978, 2252.699076, 2400.679973, 759.6106373, 2119.615818, 2237.776491, 2805.980462, 2121.357381, 3697.413703, 1016.568159, 2644.190708, 767.467996, 1466.592337, 1607.868897, 5086.535016, 432.3807671, 1421.195101, 1927.459954, 339.809833, 524.0106824, 3764.976117, 1478.59734, 1602.688698, 344.4178814, 1143.580404, 3419.977131, 826.2707372, 640.4341078, 1459.411497, 691.0806014, 3084.482426 ]
      }
    ]
}